import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('interazioniPagine');
export const actions = helper.createActions('interazioniPagine', actionTypes);